<template>
  <div :style="dependenciesComponentsStyleList">
    <span
      class="ui-icon-circle-close error--text mx-auto mb-3 d-block"
      :style="canceledIconStyleList"
    />
    <div class="text-h5 text--text mb-4 text-center">
      Платёж не прошёл
    </div>
    <div class="text-body-1 text-secondary--text mb-6 text-center">
      Деньги с вашей карты не списаны.
      <br>
      Попробуйте оплатить ещё раз.
    </div>
    <button
      :class="buttonDeviceClassList"
      class="b-button b-button_blue"
      @click="handleButtonClickOnce"
    >
      <span class="text-button">
        Повторить
      </span>
    </button>
  </div>
</template>

<script>
import {
  ClubStyleData,
  ClubEventsNames,
  ClubGlobalData,
} from 'www/vue_components/common/Club/mixins'
import { sendClubData } from 'www/vue_components/common/Club/api'
import { alertUserErrors } from 'www/vue_components/common/Club/functions'

export default {
  name: 'ClubAppointmentFailed',
  mixins: [
    ClubGlobalData,
    ClubStyleData,
    ClubEventsNames,
  ],
  data: () => ({
    isDisallowClick: false,
  }),
  methods: {
    handleButtonClickOnce() {
      if (this.isDisallowClick) {
        return
      }

      const requestBody = {
        data: {},
        couponRequestId: this.couponRequestId,
      }

      this.isDisallowClick = true
      sendClubData(requestBody)
        .then(response => this.$emit(this.eventClubClickPayment, { response }))
        .catch(error => {
          this.isDisallowClick = false
          alertUserErrors(error)
        })
    },
  },
}
</script>
